<template>
  <div class='EnbPainel'>
    <global-spinner v-if="GlobalLoading"/>
    <enb-msg/>
    <enb-modal v-if="EnbModal.active"/>
    <enb-sidebar/>
    <side-nave-mobi-painel v-if="SideNave"/>
    <div class="cont-painel">
      <enb-nave-mobi-painel/>
      <div class="label">
        <enb-label
        :text="textLabel"
        config="font-weight:bold;font-size:18px;color:#648EEA;text-align:left;padding:1.5%"
        />
        <div class="sub-link" v-if="subLink" @click="$router.push(subLink.path)">
          {{ subLink.text }}
        </div>
        <button class="btn-import" v-if="subLink" @click="$refs.fileImport.click()">
          {{ subLink.importText }}
        </button>
        <input
        ref="fileImport"
        type="file"
        accept=".csv,text/csv"
        style="display:none"
        @change="importFile"
        />
      </div>
      <div class="cont" >
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EnbSidebar from '@/components/EnbPainel/EnbSidebar.vue'
import EnbLabel from '@/components/EnbLabel.vue';
import EnbModal from '@/components/EnbPainel/Modal/EnbModal'
import EnbMsg from '@/components/EnbMsg/EnbMsg'
import GlobalSpinner from '@/components/Spinner/GlobalSpinner'
import Mobile from '@/components/Mobile'
export default {
  name: 'EnbPainel',
  components: { EnbSidebar, EnbLabel, EnbModal, EnbMsg, GlobalSpinner, ...Mobile },
  computed: {
    ...mapGetters(['EnbModal', 'GlobalLoading', 'Empresa', 'SideNave']),
    textLabel () {
      if(this.Empresa.modelo === 'Modelo 03') {
        if(this.$route.name === 'Produtos') {
          return 'Captações'
        }
        if(this.$route.name === 'Adicionar produto') {
          return 'Adicionar captação'
        }
        if(this.$route.name === 'Editar produto') {
          return 'Editar captação'
        }
        if(!this.$route.name) {
          return this.$route.matched[this.$route.matched.length - 2].name
        }
        return this.$route.name
      }
      if(!this.$route.name) {
        return this.$route.matched[this.$route.matched.length - 2].name
      }
      return this.$route.name
    },
    // link ao lado do título: produtos -> categorias
    subLink () {
      let links = {
        '/painel/produtos': { text: 'Categorias de produtos', path: '/painel/produtos/categorias', importText: 'Importar produtos' },
        '/painel/captacoes': { text: 'Categorias das captações', path: '/painel/captacoes/categorias', importText: 'Importar captações' }
      }
      return links[this.$route.path] || null
    }
  },
  methods: {
    ...mapActions(['ImportProduct']),
    // converte a planilha em base64 e envia para o backend
    importFile (e) {
      let file = e.target.files[0]
      if(!file) return
      let reader = new FileReader()
      reader.onload = () => {
        this.ImportProduct(reader.result)
      }
      reader.readAsDataURL(file)
      // permite selecionar o mesmo arquivo de novo
      e.target.value = ''
    }
  }
}
</script>

<style scoped>
.EnbPainel {
  width: 100%;
  height: 100%;
  display: flex;
}

.cont-painel {
  width: 80%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 0px 4px 1px #CCCCCC;
}

.label {
  height: 8%;
  display: flex;
  align-items: center;
}

.sub-link {
  font-size: 16px;
  color: #648EEA;
  text-decoration: underline;
  cursor: pointer;
}

.btn-import {
  margin-left: 15px;
  padding: 6px 12px;
  font-size: 14px;
  color: #FFFFFF;
  background: #648EEA;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

/* ocupa o restante da altura (no mobile a nave do topo também divide o espaço) */
.cont {
  flex: 1;
  min-height: 0;
}

@media (max-width: 500px) {
  .cont-painel {
    width: 100%;
  }

  /* no mobile o título ocupa a linha toda; o link vai embaixo */
  .label {
    height: auto;
    flex-direction: column;
  }
}
</style>
